<script>
  export default {
    props: {
      autofocus: {
        type: Boolean,
        reqiured: false,
        default: false
      }
    },
    methods: {
      handleFocusOut () {
        this.$emit('blur')
      }
    },
    mounted () {
      if (this.autofocus) {
        this.$refs.editor.$refs.content.focus()
      }

      this.$refs.editor.$refs.content.addEventListener('focusout', this.handleFocusOut)
    },
    unmounted () {
      this.$refs.editor.$refs.content.removeEventListener('focusout', this.handleFocusOut)
    },
    render (h) {
      return h('q-editor', {
        props: this.$props,
        attrs: this.$attrs,
        on: this.$listeners,
        ref: 'editor'
      })
    }
  }
</script>
